import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button/Button';

import { commonStyles } from '../styles/styles';

import noRouteBg from '../assets/no_route_bg.jpg';

const NoRoute = ({ classes }) => (
  <div className={classes.page}>
    <Typography className={classes.text}>
      Oops,
      <br /> something went wrong
    </Typography>
    <Typography className={classes.subtext}>Error 404. Page not found.</Typography>
    <Link to="/" className={classes.link}>
      <Button
        variant="contained"
        type="submit"
        className={`${classes.defaultButton} ${classes.button}`}
      >
        HOME
      </Button>
    </Link>
  </div>
);

const styles = theme => ({
  ...commonStyles,
  button: {
    display: 'block',
    width: 100,
    margin: '0 auto',
  },
  page: {
    background: `url(${noRouteBg}) center 0 no-repeat`,
    backgroundSize: 'cover',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '90vh',
    flexDirection: 'column',
    textAlign: 'center',
  },
  text: {
    color: theme.palette.primary.contrastText,
    fontSize: 36,
    fontWeight: 900,
  },
  subtext: {
    color: theme.palette.primary.contrastText,
    fontSize: 20,
    fontWeight: 400,
    marginBottom: 20,
  },
});

export default compose(withStyles(styles))(NoRoute);

NoRoute.propTypes = {
  classes: PropTypes.instanceOf(Object),
};



// WEBPACK FOOTER //
// ./src/Screens/NoRoute.jsx